export const getIsMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent, 'v')
  const reg =
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  return userAgent.match(reg) ? true : false;
};

/**
 * 验证手机号格式
 * @param {string} phone - 手机号
 * @returns {boolean} - 是否为有效的手机号
 */
export const validatePhone = (phone) => {
  if (!phone) return true;
  const phoneReg = /^1[3-9]\d{9}$/;
  return phoneReg.test(phone);
};

/**
 * 将图片URL转换为base64编码
 * @param {string} url - 图片URL地址
 * @param {number} timeout - 超时时间（毫秒），默认10000ms
 * @returns {Promise<string>} - 返回base64编码的图片数据
 */
export const imageUrlToBase64 = (url, timeout = 10000) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error('图片URL为空'));
      return;
    }

    if (url.startsWith('data:')) {
      resolve(url);
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';

    const timer = setTimeout(() => {
      reject(new Error('图片加载超时: ' + url));
    }, timeout);

    img.onload = () => {
      clearTimeout(timer);
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/jpeg', 0.8);
        resolve(dataURL);
      } catch (e) {
        reject(new Error('图片转换base64失败: ' + e.message));
      }
    };

    img.onerror = () => {
      clearTimeout(timer);
      reject(new Error('图片加载失败: ' + url));
    };

    img.src = url;
  });
};

/**
 * 批量预加载图片URL并转换为base64
 * @param {Object} imageMap - 图片映射对象，键为标识名，值为URL
 * @param {number} timeout - 单张图片超时时间（毫秒），默认10000ms
 * @returns {Promise<Object>} - 返回转换后的映射对象，值为base64数据
 */
export const preloadImages = (imageMap, timeout = 10000) => {
  const entries = Object.entries(imageMap);
  const tasks = entries.map(([key, url]) => {
    if (!url) {
      return Promise.resolve([key, '']);
    }
    return imageUrlToBase64(url, timeout)
      .then(base64 => [key, base64])
      .catch(err => {
        console.warn(`图片预加载失败[${key}]:`, err.message);
        return [key, ''];
      });
  });

  return Promise.all(tasks).then(results => {
    const resultMap = {};
    results.forEach(([key, base64]) => {
      resultMap[key] = base64;
    });
    return resultMap;
  });
};
